import React, { useState, useEffect, useMemo } from "react";

import { Row, Col } from "react-bootstrap";

//apexcharts
import Chart from "react-apexcharts";

// service
import ReportService from "../../services/report/ReportService";

//img
import shapes1 from "../../assets/images/shapes/01.png";
import shapes2 from "../../assets/images/shapes/02.png";
import shapes3 from "../../assets/images/shapes/03.png";
import shapes4 from "../../assets/images/shapes/04.png";
import shapes5 from "../../assets/images/shapes/05.png";

//progressbar
import Progress from "../../components/progress.js";

import { Link } from "react-router-dom";

const Statistik = () => {
  let RepService = useMemo(() => new ReportService(), []);
  // data
  const [frequensi, setFrequensi] = useState([]); // data frequensi
  const [frequensiUpt, setFrequensiUpt] = useState([]); // data frequensi upt
  const [jumfreq, setJumfreq] = useState(0);
  const [frequensiNegara, setFrequensiNegara] = useState([]);

  useEffect(() => {
    getFrequensi();
    getFrequensiUpt();
    getCntFreq();
    getFrequensiNegara();
  }, []);

  const getFrequensi = async () => {
    const response = await RepService.getFrequensi()
    setFrequensi(response.data)
  };

  const getFrequensiUpt = async () => {
    const response = await RepService.getFrequensiUpt()
    setFrequensiUpt(response.data)
  };

  const getFrequensiNegara = async () => {
    const response = await RepService.getFrequensiNegara()
    setFrequensiNegara(response.data)
  };

  const getCntFreq = async () => {
    const response = await RepService.getCntFreq()
    setJumfreq(response.data)
  };

  const getVariableColor = () => {
    let prefix =
      getComputedStyle(document.body).getPropertyValue("--prefix") || "bs-";
    if (prefix) {
      prefix = prefix.trim();
    }
    const color1 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}primary`
    );
    const color2 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}info`
    );
    const color3 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}primary-tint-20`
    );
    const color4 = getComputedStyle(document.body).getPropertyValue(
      `--${prefix}warning`
    );
    return {
      primary: color1.trim(),
      info: color2.trim(),
      warning: color4.trim(),
      primary_light: color3.trim(),
    };
  };
  const variableColors = getVariableColor();
  const colors = [variableColors.primary, variableColors.info];

  //chart1
  const chart1 = {
    options: {
      chart: {
        fontFamily:
          '"Inter", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
        toolbar: {
          show: false,
        },
        sparkline: {
          enabled: false,
        },
      },
      colors: colors,
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 3,
      },
      yaxis: {
        show: true,
        labels: {
          show: true,
          minWidth: 19,
          maxWidth: 19,
          style: {
            colors: "#8A92A6",
          },
          offsetX: -5,
        },
      },
      legend: {
        show: false,
      },
      xaxis: {
        labels: {
          minHeight: 22,
          maxHeight: 22,
          show: true,
          style: {
            colors: "#8A92A6",
          },
        },
        lines: {
          show: false, //or just here to disable only x axis grids
        },
        categories: frequensi.map(item => item?.TANGGAL),
      },
      grid: {
        show: false,
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "vertical",
          shadeIntensity: 0,
          gradientToColors: undefined, // optional, if not defined - uses the shades of same color in series
          inverseColors: true,
          opacityFrom: 0.4,
          opacityTo: 0.1,
          stops: [0, 50, 80],
          colors: colors,
        },
      },
      tooltip: {
        enabled: true,
      },
    },
    series: [
      {
        name: "Jumlah",
        data: frequensi.map(item => item?.JUMLAH),
      },
    ],
  };

  return (
    <>
      <div className="header">
        <section className="register-content">
          <Row className="m-0 align-items-center bg-white vh-100">
            <Col md="12" lg="8">
              <Row>
                <Col md="12">
                  {/* <div className="card" data-aos="fade-up" data-aos-delay="800"> */}
                  <div className="card">
                    <div className="flex-wrap card-header d-flex justify-content-between">
                      <div className="header-title">
                        <h4 className="card-title">Frequensi Ekspor</h4>
                        <p className="mb-0">Bulan Maret 2025</p>
                      </div>
                      <div className="d-flex align-items-center align-self-center">
                      </div>
                    </div>
                    <div className="card-body">
                      <Chart
                        options={chart1.options}
                        series={chart1.series}
                        type="area"
                        height="245"
                      />
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col md="12" lg="4">
              <Row>
                <div
                  className="overflow-hidden card"
                // data-aos="fade-up"
                // data-aos-delay="600"
                >
                  <div className="flex-wrap card-header d-flex justify-content-between">
                    <div className="header-title">
                      <h4 className="mb-2 card-title">Frequensi Per Negara</h4>
                      {/* <p className="mb-0">
                      <svg
                        className="me-2"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#3a57e8"
                          d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"
                        />
                      </svg>
                      15 new acquired this month
                    </p> */}
                    </div>
                  </div>
                  <div className="p-0 card-body">
                    <div className="mt-4 table-responsive">
                      <table
                        id="basic-table"
                        className="table mb-0 table-striped"
                        role="grid"
                      >
                        <thead>
                          <tr>
                            <th>NEGARA</th>
                            <th>FREQUENSI</th>
                            <th>PERSENTASE</th>
                          </tr>
                        </thead>
                        <tbody>
                          {frequensiNegara.map((freqnegara, index) => (
                            <tr >
                              <td>
                                <img
                                  src={`https://flagcdn.com/w40/${freqnegara.kode_negara_partner.toLowerCase()}.png`}
                                  alt={`Bendera ${freqnegara.negara_tujuan}`}
                                  width="40"
                                />
                              </td>
                              {/* <td>
                                <div className="d-flex align-items-center">
                                  <h6>{freqnegara.URAIAN_NEGARA}</h6>
                                </div>
                              </td> */}
                              <td>{freqnegara.JUMLAH}</td>
                              <td>
                                <div className="mb-2 d-flex align-items-center">
                                  <h6>{((freqnegara.JUMLAH / jumfreq) * 100).toFixed(2)}{"%"}</h6>
                                </div>
                                <Progress
                                  softcolors="primary"
                                  color="primary"
                                  className="shadow-none w-100"
                                  value={(freqnegara.JUMLAH / jumfreq) * 100}
                                  minvalue={0}
                                  maxvalue={100}
                                  style={{ height: "4px" }}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </Row>
            </Col>
            <Col md="12" lg="8">
              <div
                className="overflow-hidden card"
              // data-aos="fade-up"
              // data-aos-delay="600"
              >
                <div className="flex-wrap card-header d-flex justify-content-between">
                  <div className="header-title">
                    <h4 className="mb-2 card-title">Frequensi Per UPT</h4>
                    {/* <p className="mb-0">
                      <svg
                        className="me-2"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#3a57e8"
                          d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"
                        />
                      </svg>
                      15 new acquired this month
                    </p> */}
                  </div>
                </div>
                <div className="p-0 card-body">
                  <div className="mt-4 table-responsive">
                    <table
                      id="basic-table"
                      className="table mb-0 table-striped"
                      role="grid"
                    >
                      <thead>
                        <tr>
                          <th>UPT</th>
                          <th>VOLUME</th>
                          <th>FREQUENSI</th>
                          <th>PERSENTASE</th>
                        </tr>
                      </thead>
                      <tbody>
                        {frequensiUpt.map((frequpt, index) => (
                          <tr >
                            <td>
                              <div className="d-flex align-items-center">
                                <h6>{index + 1} {". "} {frequpt.UPT}</h6>
                              </div>
                            </td>
                            <td>{(frequpt.TOTAL_NETTO / 1000).toFixed(2)}</td>
                            <td>{frequpt.JUMLAH}</td>
                            <td>
                              <div className="mb-2 d-flex align-items-center">
                                <h6>{((frequpt.JUMLAH / jumfreq) * 100).toFixed(2)}{"%"}</h6>
                              </div>
                              <Progress
                                softcolors="primary"
                                color="primary"
                                className="shadow-none w-100"
                                value={(frequpt.JUMLAH / jumfreq) * 100}
                                minvalue={0}
                                maxvalue={100}
                                style={{ height: "4px" }}
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </section>
      </div>
    </>
  );
};

export default Statistik;
